import{resolveAsset}from'../utils/assets'

const curatedImages = [
  { match: ['food & beverage', 'food and beverage', '食品饮料', '飲品酒水', '饮品酒水'], file: 'food.webp' },
  { match: ['photo & pendant accessories', 'photo and pendant accessories', '摄影配件', '攝影配件', '拍照配件', '吊坠配件'], file: 'photo.webp' },
  { match: ['plush toy', '毛绒玩具', '毛絨玩具', '布绒玩具', '布絨玩具'], file: 'plush.webp' },
  { match: ['furniture cupboard', '居家橱柜', '家具橱柜', '家具櫥櫃'], file: 'furniture.webp' },
  { match: ['protective suit', '防护服', '防護服'], file: 'protective.webp' },
  { match: ['winter sports', '冬季运动', '冬季運動'], file: 'winter.webp' },
  { match: ['lure', '路亚', '路亞', '鱼饵', '魚餌'], file: 'lure.webp' },
  { match: ["women's shirt", 'womens shirt', '女式衬衫', '女士衬衫', '女式襯衫', '女款衬衫', '女款襯衫'], file: 'shirt.webp' }
  ,{ match: ['office accessories', '办公室配件', '辦公室配件'], file: 'office-accessories.jpg' }
  ,{ match: ["children's bags", 'childrens bags', '儿童包包', '兒童包包'], file: 'childrens-bags.jpg' }
  ,{ match: ['backpack', '背包'], file: 'backpacks.jpg' }
  ,{ match: ['laptop', '笔记本电脑', '筆記本電腦'], file: 'category-extra.jpg' }
]

const curatedCategoryImage = name => {
  const value = String(name || '').trim().toLowerCase()
  const entry = curatedImages.find(item => item.match.some(label => value.includes(label.toLowerCase())))
  return entry ? `/assets/category/${entry.file}` : ''
}
const positionalFallback = index => index >= 8 && index < 12 ? `/assets/category/${['office-accessories.jpg','childrens-bags.jpg','backpacks.jpg','category-extra.jpg'][index - 8]}` : ''

export const adaptCategory=(raw={},index=0)=>{const id=raw.id||raw.categoryId||raw.categoryUuid||raw.sysCategoryId||raw.uuid||raw.UUID||raw.code||raw.name;const name=raw.name||raw.categoryName||raw.title||'Category';return{id,name,image:curatedCategoryImage(name)||positionalFallback(index)||resolveAsset(raw.iconImg||raw.image||raw.imgUrl,'category',`${id}-${index}`),raw}}
export const adaptCategories=list=>(list||[]).map((item,index)=>adaptCategory(item,index))
